import SectionHeading from "@/components/base/SectionHeading";
import { discussTopics, methodPoints } from "@/mocks/home";

export default function MethodSection() {
  return (
    <section id="methods" className="relative w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <SectionHeading
        eyebrow="METHODOLOGY"
        title="四个维度，把一张照片看穿"
        desc="不靠感觉下结论。每张黑料照片都会依次过一遍这四个维度，结论必须由证据支撑。"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {methodPoints.map((point, idx) => (
          <div
            key={point.title}
            className="group rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 hover:border-primary-300 transition-colors"
          >
            <div className="flex items-center justify-between">
              <span className="w-11 h-11 rounded-md bg-primary-100 flex items-center justify-center">
                <i className={`${point.icon} text-xl text-primary-600`}></i>
              </span>
              <span className="font-heading font-black text-2xl text-background-300">
                0{idx + 1}
              </span>
            </div>
            <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 mt-4">
              {point.title}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mt-2">
              {point.desc}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-8 rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
        <div className="flex flex-col md:flex-row md:items-center gap-4">
          <div className="shrink-0 flex items-center gap-2">
            <i className="ri-price-tag-3-line text-accent-600"></i>
            <span className="font-heading font-bold text-sm text-foreground-950 whitespace-nowrap">
              讨论热度标签
            </span>
          </div>
          <div className="flex flex-wrap gap-2">
            {discussTopics.map((topic) => (
              <a
                key={topic.name}
                href="#discuss"
                className="inline-flex items-center gap-1.5 font-label text-xs px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 hover:bg-accent-100 hover:text-accent-900 transition-colors cursor-pointer"
              >
                {topic.name}
                <span className="text-[10px] text-foreground-400">{topic.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}